import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'contextual-summary.title',
		defaultMessage: 'Summary',
		description: 'The title for the Jira summary page',
	},
	feedbackPrompt: {
		id: 'contextual-summary.feedback-prompt',
		defaultMessage:
			'<message>Was the information shown in this page useful?</message> <button>Give us feedback</button>',
		description: 'Prompt for feedback on the JSW summary page',
	},
	emptyStateTitle: {
		id: 'spa-apps.software.summary.empty-state-title',
		defaultMessage: 'We’re unable to show your summary',
		description: 'Empty State title for the summary page',
	},
	emptyStateDescription: {
		id: 'spa-apps.software.summary.empty-state-description',
		defaultMessage: 'Try refreshing the page, or check your connection.',
		description: 'Empty State description for summary page',
	},
	emptyStateRefreshButton: {
		id: 'spa-apps.software.summary.empty-state-refresh-button',
		defaultMessage: 'Refresh',
		description: 'Empty state text on the refresh button for summary page',
	},
});
